<template>
    <header>
        <div class="container">
            <nav class="nav">
                <router-link to="/">
                    <Logo />
                </router-link>
                <ul class="nav-links">
                    <li
                        class="nav-links__item"
                        v-for="navLink in navLinks"
                        :key="navLink.id"
                    >
                        <router-link
                            :to="navLink.id"
                            id="nav-link"
                            :class="{
                                active: currentRoute === `/${navLink.id}`,
                            }"
                            >{{ navLink.name }}</router-link
                        >
                    </li>
                </ul>
                <ul class="nav-social">
                    <li class="nav-social__item">
                        <a
                            href="https://www.linkedin.com/company/retail-only-i-sverige-ab/"
                            target="_blank"
                        >
                            <svg
                                width="30"
                                height="30"
                                viewBox="0 0 30 30"
                                class="nav-social__item--linkedin"
                            >
                                <path
                                    d="M15.0001 0.600006C7.0471 0.600006 0.600098 7.04701 0.600098 15C0.600098 22.953 7.0471 29.4 15.0001 29.4C22.9531 29.4 29.4001 22.953 29.4001 15C29.4001 7.04701 22.9531 0.600006 15.0001 0.600006ZM11.4751 20.9685H8.5591V11.5845H11.4751V20.9685ZM9.9991 10.4325C9.0781 10.4325 8.4826 9.78001 8.4826 8.97301C8.4826 8.14951 9.0961 7.51651 10.0366 7.51651C10.9771 7.51651 11.5531 8.14951 11.5711 8.97301C11.5711 9.78001 10.9771 10.4325 9.9991 10.4325ZM22.1251 20.9685H19.2091V15.768C19.2091 14.5575 18.7861 13.7355 17.7316 13.7355C16.9261 13.7355 16.4476 14.292 16.2361 14.8275C16.1581 15.018 16.1386 15.288 16.1386 15.5565V20.967H13.2211V14.577C13.2211 13.4055 13.1836 12.426 13.1446 11.583H15.6781L15.8116 12.8865H15.8701C16.2541 12.2745 17.1946 11.3715 18.7681 11.3715C20.6866 11.3715 22.1251 12.657 22.1251 15.42V20.9685V20.9685Z"
                                    fill="#E8B7B8"
                                />
                            </svg>
                        </a>
                        <a
                            href="https://www.facebook.com/Retail-Only-465857273847638/"
                            target="_blank"
                        >
                            <svg
                                width="30"
                                height="30"
                                viewBox="0 0 30 30"
                                class="nav-social__item--facebook"
                            >
                                <path
                                    d="M15.0001 0.600006C7.0471 0.600006 0.600098 7.04701 0.600098 15C0.600098 22.953 7.0471 29.4 15.0001 29.4C22.9531 29.4 29.4001 22.953 29.4001 15C29.4001 7.04701 22.9531 0.600006 15.0001 0.600006ZM18.4111 10.551H16.2466C15.9901 10.551 15.7051 10.8885 15.7051 11.337V12.9H18.4126L18.0031 15.129H15.7051V21.8205H13.1506V15.129H10.8331V12.9H13.1506V11.589C13.1506 9.70801 14.4556 8.17951 16.2466 8.17951H18.4111V10.551V10.551Z"
                                    fill="#E8B7B8"
                                />
                            </svg>
                        </a>
                    </li>
                </ul>
                <div class="nav-mobile">
                    <div id="mobile-nav" @click="handleMobileNavToggle">
                        <div class="nav-mobile__menu"></div>
                    </div>
                    <div
                        class="nav-mobile__links"
                        :class="{ 'mobile-nav-open': isMobileMenuOpen }"
                    >
                        <svg
                            width="30"
                            height="30"
                            viewBox="0 0 24 24"
                            class="nav-mobile__links-close"
                            id="mobile-nav-close"
                            @click="handleMobileNavToggle"
                        >
                            <path
                                d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                                fill="white"
                            />
                        </svg>
                        <ul class="nav-mobile__links-list">
                            <li
                                v-for="navLink in navLinks"
                                :key="navLink.id"
                                class="nav-mobile__links-list-item"
                            >
                                <router-link
                                    :to="navLink.id"
                                    @click="handleMobileNavlinkClick"
                                    >{{ navLink.name }}</router-link
                                >
                            </li>
                        </ul>

                        <ul class="nav-mobile__social">
                            <li class="nav-mobile__social-item">
                                <a
                                    href="https://www.linkedin.com/company/retail-only-i-sverige-ab/"
                                    target="_blank"
                                >
                                    <svg
                                        width="50"
                                        height="50"
                                        viewBox="0 0 30 30"
                                        class="nav-mobile__social-linkedin"
                                    >
                                        <path
                                            d="M15.0001 0.600006C7.0471 0.600006 0.600098 7.04701 0.600098 15C0.600098 22.953 7.0471 29.4 15.0001 29.4C22.9531 29.4 29.4001 22.953 29.4001 15C29.4001 7.04701 22.9531 0.600006 15.0001 0.600006ZM11.4751 20.9685H8.5591V11.5845H11.4751V20.9685ZM9.9991 10.4325C9.0781 10.4325 8.4826 9.78001 8.4826 8.97301C8.4826 8.14951 9.0961 7.51651 10.0366 7.51651C10.9771 7.51651 11.5531 8.14951 11.5711 8.97301C11.5711 9.78001 10.9771 10.4325 9.9991 10.4325ZM22.1251 20.9685H19.2091V15.768C19.2091 14.5575 18.7861 13.7355 17.7316 13.7355C16.9261 13.7355 16.4476 14.292 16.2361 14.8275C16.1581 15.018 16.1386 15.288 16.1386 15.5565V20.967H13.2211V14.577C13.2211 13.4055 13.1836 12.426 13.1446 11.583H15.6781L15.8116 12.8865H15.8701C16.2541 12.2745 17.1946 11.3715 18.7681 11.3715C20.6866 11.3715 22.1251 12.657 22.1251 15.42V20.9685V20.9685Z"
                                            fill="#E8B7B8"
                                        />
                                    </svg>
                                </a>
                            </li>
                            <li class="nav-mobile__social-item">
                                <a
                                    href="https://www.facebook.com/Retail-Only-465857273847638/"
                                    target="_blank"
                                >
                                    <svg
                                        width="50"
                                        height="50"
                                        viewBox="0 0 30 30"
                                        class="nav-mobile__social-facebook"
                                    >
                                        <path
                                            d="M15.0001 0.600006C7.0471 0.600006 0.600098 7.04701 0.600098 15C0.600098 22.953 7.0471 29.4 15.0001 29.4C22.9531 29.4 29.4001 22.953 29.4001 15C29.4001 7.04701 22.9531 0.600006 15.0001 0.600006ZM18.4111 10.551H16.2466C15.9901 10.551 15.7051 10.8885 15.7051 11.337V12.9H18.4126L18.0031 15.129H15.7051V21.8205H13.1506V15.129H10.8331V12.9H13.1506V11.589C13.1506 9.70801 14.4556 8.17951 16.2466 8.17951H18.4111V10.551V10.551Z"
                                            fill="#E8B7B8"
                                        />
                                    </svg>
                                </a>
                            </li>
                        </ul>

                        <Logo class="nav-mobile__links-list-logo" />
                    </div>
                </div>
            </nav>
        </div>
    </header>
</template>

<script lang="ts">
import { defineComponent, ref, toRefs, watch } from 'vue'
import { useRoute } from 'vue-router'

// Components
import Logo from './Logo.vue'

export default defineComponent({
    name: 'Header',
    components: {
        Logo,
    },
    props: {
        isMobileMenuOpen: { type: Boolean, default: false },
    },
    setup(props, { emit }) {
        const { isMobileMenuOpen } = toRefs(props)
        const route = useRoute()
        const currentRoute = ref('/')

        const navLinks = [
            { id: '/', name: 'Hem' },
            {
                id: 'services',
                name: 'Tjänster',
            },
            {
                id: 'idea-vision',
                name: 'Idé & Vision',
            },
            {
                id: 'contact',
                name: 'Kontakta oss',
            },
        ]

        const handleMobileNavToggle = () => {
            const closeBtn = document.getElementById('mobile-nav-close')

            if (!isMobileMenuOpen.value) {
                closeBtn?.classList.add('animate')
            } else {
                closeBtn?.classList.remove('animate')
            }

            emit('toggle-mobile-menu', !isMobileMenuOpen)
        }

        const handleMobileNavlinkClick = () => {
            handleMobileNavToggle()
        }

        watch(route, () => {
            currentRoute.value = route.path
        })

        return {
            navLinks,
            currentRoute,
            handleMobileNavToggle,
            handleMobileNavlinkClick,
        }
    },
})
</script>

<style lang="scss" scoped>
@import '../../styles/variables';
@import '../../styles/mixins';
@import '../../styles/config';

header {
    font-family: $font-family-header;
    z-index: 99;
    position: fixed;
    top: 0;
    left: 0;
    background-color: $header-background-color;
    width: 100%;
    height: var(--header-height);
    padding: 1rem;

    @include mQ(900px) {
        padding: 1rem 0;
        background-color: transparent;
        position: absolute;
    }
}

.nav {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &-links {
        display: flex;
        list-style-type: none;

        @include mQ(900px) {
            & {
                display: none;
            }
        }

        &__item {
            position: relative;
            margin-right: 40px;
            overflow-x: hidden;
            padding-bottom: 5px;
            overflow-y: hidden;
            font-size: 1.1rem;

            &:last-of-type {
                margin-right: 0;
            }

            a::before {
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                width: 100%;
                height: 3px;
                background-color: $accent-color;
                transition: transform 250ms ease-in;
                transform: scale(0);
            }

            a:active::before,
            a:focus::before,
            a:hover::before,
            a.active::before {
                transform: scale(1);
            }

            a:visited,
            a:link {
                color: $font-color-main-grey;
                transition: color 250ms ease-in;
                font-weight: 500;
            }
        }
    }

    &-social {
        display: flex;
        list-style-type: none;

        @include mQ(900px) {
            & {
                display: none;
            }
        }

        &__item {
            &--linkedin {
                margin-right: 0.25rem;
            }

            a:visited,
            a:link {
                text-decoration: none;

                &:hover .nav-social__item--linkedin path {
                    fill: $linkedin-color;
                }

                &:hover .nav-social__item--facebook path {
                    fill: $facebook-color;
                }
            }

            &--linkedin path,
            &--facebook path {
                transition: fill 250ms ease-in;
            }
        }
    }

    &-mobile {
        display: none;
        position: relative;
        z-index: 90;

        #mobile-nav {
            position: fixed;
            top: 1.3rem;
            right: 1.5rem;
            width: 50px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            border-radius: 5px;
        }

        &__menu {
            position: relative;
            height: 3px;
            width: 30px;
            background: $font-color-main-grey;

            &::before,
            &::after {
                content: '';
                position: absolute;
                height: 3px;
                background: $font-color-main-grey;
            }

            &::before {
                content: '';
                top: -8px;
                left: 0;
                width: 30px;
            }

            &::after {
                content: '';
                top: 8px;
                left: 0;
                width: 20px;
            }
        }

        &__links {
            position: fixed;
            height: 100%;
            width: 100%;
            top: 0;
            left: 0;
            background: linear-gradient(
                to bottom left,
                $accent-color-very-light,
                #fff
            );
            // background: rgba(255, 255, 255, 0.95);
            z-index: 100;
            transition: transform 300ms ease-in-out;
            transform: translatex(100%);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            &-close {
                position: absolute;
                top: 1.3rem;
                right: 1.5rem;
                width: 50px;
                height: 50px;
                cursor: pointer;
                z-index: 200;

                &.animate {
                    animation-name: rotate;
                    animation-delay: 200ms;
                    animation-duration: 800ms;
                    animation-timing-function: ease;

                    @keyframes rotate {
                        0% {
                            transform: rotate(0deg);
                        }
                        100% {
                            transform: rotate(540deg);
                        }
                    }
                }

                path {
                    fill: $accent-color;
                }
            }

            &-list {
                position: relative;
                display: flex;
                flex-direction: column;
                list-style-type: none;
                align-items: center;
                justify-content: center;
                width: 100%;

                &-item {
                    font-size: 2rem;

                    &:not(:last-of-type) {
                        margin-bottom: 1rem;
                    }

                    a {
                        color: $font-color-main-grey;
                    }
                }

                &-logo {
                    position: absolute;
                    bottom: 5vh;
                    left: 50%;
                    transform: translateX(-50%);
                }
            }

            &.mobile-nav-open {
                transform: translateX(0%);
            }
        }

        @include mQ(900px) {
            & {
                display: flex;
            }
        }

        &__social {
            display: flex;
            list-style: none;
            margin-top: 4rem;

            & li:first-of-type {
                margin-right: 0.5rem;
            }
        }
    }
}
</style>
